import { config } from "../Constants";

export const fetchWithAuth = async (url, options = {}) => {
    const token = localStorage.getItem('authToken');

    const headers = {
        'Content-Type': 'application/json',
        ...options.headers
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const requestUrl = url.startsWith('http') ? url : `${config.url}${url}`;

    try {
        const response = await fetch(requestUrl, {
            ...options,
            headers,
            credentials: 'include'
        });

        if (response.status === 401) {
            console.warn(`Authentication error for ${url}`);

            const authErrorEvent = new CustomEvent('auth:error', {
                detail: { status: 401, url }
            });
            window.dispatchEvent(authErrorEvent);
        }

        return response;
    } catch (error) {
        if (error?.name !== 'AbortError') {
            console.error(`Network error for ${url}:`, error);
        }
        throw error;
    }
};

export const refreshAuthToken = async () => {
    try {
        const currentToken = localStorage.getItem('authToken');
        if (!currentToken) return false;

        const response = await fetchWithAuth('/api/v1/auth/refresh', {
            method: 'POST'
        });

        if (response.ok) {
            const data = await response.json();
            if (data.result === 'SUCCESS' && data.data) {
                localStorage.setItem('authToken', data.data);
                return true;
            }
        }
        return false;
    } catch (error) {
        console.error('Failed to refresh token:', error);
        return false;
    }
};
